"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowSpacingBeforeApplier = exports.TableRowSpacingBeforeApplier = void 0;
var layout_row_1 = require("../../../layout/main-structures/layout-row");
var layout_box_1 = require("../../../layout/main-structures/layout-boxes/layout-box");
var TableRowSpacingBeforeApplier = (function () {
    function TableRowSpacingBeforeApplier(lastRow, paragraphs, isFirstRowInCell, isFirstCellInRow, isFirstRowInTable) {
        this.lastRow = lastRow;
        this.paragraphs = paragraphs;
        this.isFirstRowInCell = isFirstRowInCell;
        this.isFirstCellInRow = isFirstCellInRow;
        this.isFirstRowInTable = isFirstRowInTable;
    }
    TableRowSpacingBeforeApplier.prototype.apply = function (row, rowParagraphIndex) {
        row.applySpacingBefore(this.lastRow && !this.lastRow.flags.get(layout_row_1.LayoutRowStateFlags.ParagraphEnd) ? 0 :
            layout_row_1.LayoutRow.getParagraphSpacingBefore(this.paragraphs[rowParagraphIndex], this.paragraphs[rowParagraphIndex - 1], this.isFirstRowInCell, this.isFirstCellInRow, this.isFirstRowInTable));
    };
    return TableRowSpacingBeforeApplier;
}());
exports.TableRowSpacingBeforeApplier = TableRowSpacingBeforeApplier;
var RowSpacingBeforeApplier = (function () {
    function RowSpacingBeforeApplier(settings, lastRowInfo, paragraphs, isFirstRowOnColumn) {
        this.settings = settings;
        this.lastRowInfo = lastRowInfo;
        this.paragraphs = paragraphs;
        this.isFirstRowOnColumn = isFirstRowOnColumn;
    }
    RowSpacingBeforeApplier.prototype.apply = function (row, rowParagraphIndex) {
        row.applySpacingBefore(this.calculateSpacingBefore(row, rowParagraphIndex));
    };
    RowSpacingBeforeApplier.prototype.calculateSpacingBefore = function (row, rowParagraphIndex) {
        var lastRow = this.lastRowInfo.row;
        if (this.firstRowOfSection() || (lastRow.tableCellInfo && !this.isFirstRowOnColumn)) {
            return layout_row_1.LayoutRow.getParagraphSpacingBefore(this.paragraphs[rowParagraphIndex], null, false, false, false);
        }
        else if (rowParagraphIndex == this.lastRowInfo.paragraphIndex) {
            if (this.firstRowOfParagraphStartingWithPageBreak() && this.settings.allowParagraphSpacingAfterPageBreak)
                return layout_row_1.LayoutRow.getParagraphSpacingBefore(this.paragraphs[rowParagraphIndex], null, false, false, false);
        }
        else if (!this.isFirstRowOnColumn && !this.rowConsistsOfPageBreakOnly(row)) {
            return layout_row_1.LayoutRow.getParagraphSpacingBefore(this.paragraphs[rowParagraphIndex], this.paragraphs[rowParagraphIndex - 1], false, false, false);
        }
        return 0;
    };
    RowSpacingBeforeApplier.prototype.firstRowOfSection = function () {
        return !this.lastRowInfo.row || this.lastRowInfo.row.flags.get(layout_row_1.LayoutRowStateFlags.SectionEnd);
    };
    RowSpacingBeforeApplier.prototype.rowConsistsOfPageBreakOnly = function (row) {
        return row.boxes.length == 1 && row.boxes[0].getType() == layout_box_1.LayoutBoxType.PageBreak;
    };
    RowSpacingBeforeApplier.prototype.firstRowOfParagraphStartingWithPageBreak = function () {
        return this.lastRowInfo.row && this.rowConsistsOfPageBreakOnly(this.lastRowInfo.row) &&
            this.lastRowInfo.startPosition == this.paragraphs[this.lastRowInfo.paragraphIndex].startLogPosition.value;
    };
    return RowSpacingBeforeApplier;
}());
exports.RowSpacingBeforeApplier = RowSpacingBeforeApplier;
